module.exports = __webpack_public_path__ + "static/media/accessibility-icon.d53be0da.svg";